import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as Styled from './styled';

interface SectionHeaderProps {
  /** id of the string to be used as a group label */
  labelId: string;
  /** Icon element to be shown before the label */
  Icon: React.ElementType;
}

/*
 * For more information on why this is set up with duplicate text see:
 * https://adrianroselli.com/2022/07/use-legend-and-fieldset.html
 * tl;dr: the legend element is important for accessibility but a CSS nightmare
 */
export default function SectionHeader({
  labelId,
  Icon,
}: SectionHeaderProps): React.ReactElement {
  return (
    <>
      <Styled.Legend>
        <h3>
          <FormattedMessage id={labelId} />
        </h3>
      </Styled.Legend>
      <Styled.SectionHeader aria-hidden="true">
        <Styled.SectionHeaderIcon>
          <Icon />
        </Styled.SectionHeaderIcon>
        <Styled.SectionHeaderName>
          <FormattedMessage id={labelId} />
        </Styled.SectionHeaderName>
      </Styled.SectionHeader>
    </>
  );
}
